export default class InvoiceHelper {
  static isRecourse(invoice) {
    return Number(invoice?.recourse) === 1;
  }

  static isReverse(invoice) {
    return Number(invoice?.is_reverse) === 1;
  }

  static isNonRecourse(invoice) {
    return Number(invoice?.recourse) === 0 && !this.isReverse(invoice);
  }

  static getFactoringType(invoice) {
    if (this.isReverse(invoice)) {
      return 'reverse';
    }
    if (this.isRecourse(invoice)) {
      return 'recourse';
    }
    return 'non-recourse';
  }
}
